// extracted by mini-css-extract-plugin
export default {"pic":"manageItem_pic__DSp6e","hContainer":"manageItem_hContainer__9yETW","hItem":"manageItem_hItem__kC8gi","description":"manageItem_description__zi7tN"};